import React from 'react';
import PropTypes from 'prop-types';

import FullPageQuizQuestion from 'dpl/components/FullPageQuiz/FullPageQuizQuestion';

export default function QuizCustomQuestionInterstitial({
  breederName,
  handleNextClick
}) {
  return (
    <div className="AdoptionApplicationQuizCustomQuestionInterstitial">
      <FullPageQuizQuestion
        handleNextClick={handleNextClick}
        isValid
        subtitle="This should only take a minute."
        title={`${breederName} has a few more questions.`}
      />
    </div>
  );
}

QuizCustomQuestionInterstitial.propTypes = {
  breederName: PropTypes.string.isRequired,
  handleNextClick: PropTypes.func.isRequired
};
